import { Typography } from '@material-ui/core'
import { FC } from 'react'
import { withTranslation, WithTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { selectDialogParams } from '../../../../selectors/dialogs'
import { StateInterface } from '../../../../types/states'
import { EmailConfirmationResult } from '../../../../types/users'
import Dialog from '../../../Dialog'

interface StateProps {
  emailConfirmationResult: EmailConfirmationResult | undefined
}
const mapStateToProps = (state: StateInterface): StateProps => ({
  emailConfirmationResult: selectDialogParams('EmailConfirmationResultDialog')(
    state
  )
})

type EmailConfirmationResultDialogProps = StateProps & WithTranslation

/** Email confirmation result is from URL query, pops up after user clicks email confirmation link */
const EmailConfirmationResultDialog: FC<EmailConfirmationResultDialogProps> = ({
  emailConfirmationResult,
  t
}) => (
  <Dialog
    dialogId={'EmailConfirmationResultDialog'}
    title={t(
      `EmailConfirmationResultDialog.title.${
        emailConfirmationResult?.situation || 'error'
      }`
    )}
    confirmLabel={
      emailConfirmationResult?.situation === 'success' ? t('ok') : 'ok'
    }
    noOpenDialogButton
    onlyConfirmCloses
    confirmDialogSubmitAction={() => null}
    Content={
      <div>
        <Typography variant='body1' gutterBottom>
          {t(
            `EmailConfirmationResultDialog.${
              emailConfirmationResult?.messageCode || 'generalError'
            }`
          )}
        </Typography>
      </div>
    }
  />
)

export default connect<
  StateProps,
  Record<string, never>,
  Record<string, never>,
  StateInterface
>(mapStateToProps)(withTranslation()(EmailConfirmationResultDialog))
